import { QuickMultiSelectFilter } from "@/shared/components/quick-multi-select-filter";
import styles from "./financeiro-obras-filtros.module.scss";
import type { FinanceiroObrasFiltrosViewModel } from "./types-financeiro-obras-filtros";

/** Filtros rápidos de Status e Tipo, lado a lado na barra. */
export function FinanceiroObrasFiltrosView({ status, tipo }: FinanceiroObrasFiltrosViewModel) {
  return (
    <>
      <QuickMultiSelectFilter {...status} className={styles.status} />
      <QuickMultiSelectFilter {...tipo} className={styles.tipo} />
    </>
  );
}
